import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

const getShouldShowModularOnboarding = () => {
  return GrowthAcquisitionExperiments.preview('showModularOnboarding');
};

const getShouldUseMLInferredRole = () => {
  return GrowthAcquisitionExperiments.preview('useMLInferredRole');
};

const getShouldShowOnboardingV3 = () => {
  return GrowthAcquisitionExperiments.preview('onboardingV3') !== 'control';
};

const getOnboardingV3Variant = () => {
  return GrowthAcquisitionExperiments.preview('onboardingV3');
};

const getShouldShowOnboardingV3Variant1 = () => {
  return GrowthAcquisitionExperiments.preview('onboardingV3') === 'variant1';
};

const getShouldShowOnboardingV3Variant2 = () => {
  return GrowthAcquisitionExperiments.preview('onboardingV3') === 'variant2';
};

const impressIntoOnboardingV3Experiment = () => {
  return GrowthAcquisitionExperiments.get('onboardingV3');
};

export {
  getShouldShowModularOnboarding,
  getShouldUseMLInferredRole,
  getShouldShowOnboardingV3,
  getOnboardingV3Variant,
  getShouldShowOnboardingV3Variant1,
  getShouldShowOnboardingV3Variant2,
  impressIntoOnboardingV3Experiment,
};
